import React from 'react'
import MAINLOGO from '../../assets/images/BYKUSH_Logo.png'

export default function Loader({ loadingStatus = false }) {
  return (
    loadingStatus && <div className='loader-container'>
      <div className="brand-loader-ring">
        <img src={MAINLOGO} alt="Loading ByKush..." />
      </div>
    </div>
  )
}
